











import {ChartDataTemplate, FCConfTpl, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import appConfig from '@/config'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {getStoredProcedure} from "@/data/repos/storedProcedure"


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "RoomsWithoutFunctions",
      title: "Rooms without functions",
      _description: "Rooms without functions",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: 'Function Assignment',
        rotatelabels: '1',
        setadaptiveymin: '1',
        showlegend: '1',
        labelDisplay: '$label , $value',
        showLabels: '1',
        showValues: '1',
        legendCaption: 'Rooms',
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
    }
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        return {
          data: await getStoredProcedure(
            'AnalyticsCenter',
            'widget_RoomsWithoutFunctions',
            [parseInt(params.locationId.value) || 10, 1]),
        } // todo pass all parameters
      }

      function dataplotClickCallback(label: string, val: any, data: any) {
        if (val === undefined) {
          return
        }
        const locationId = parseInt(props.config && props.config.params.locationId.value) || 10
        const url = (locationId !== 10) ?
          appConfig.IPR_BASE_URL + "/pages/cpsearch.asp?id=" + encodeURIComponent(locationId) + "&cp_id=224&criteria=Unassigned+Area"
          : appConfig.IPR_BASE_URL + "/pages/cpsearch.asp?cp_id=224&criteria=Unassigned+Area"
        window.open(url)
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
